export default __webpack_public_path__ + "static/S&FSharp-Medium-6345e74cacc3b8ccd34fe23b7cb22ec8.woff";